import { render } from "./FicheProspect.vue?vue&type=template&id=38b66acc&scoped=true"
import script from "./FicheProspect.vue?vue&type=script&lang=js"
export * from "./FicheProspect.vue?vue&type=script&lang=js"

import "./FicheProspect.vue?vue&type=style&index=0&id=38b66acc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b66acc"]])

export default __exports__